import ReactGA from 'react-ga4';

ReactGA.initialize('G-1P25GT2DEB'); // Replace with your actual tracking ID